import { deleteReconcilliationDetails } from '@app/application/reconciliation/utils'

const unsubscribers = []

export default () => {
  onDomLoad(function ($dom) {
    const deleteButton = $dom[0].querySelector(
      '[data-behavior="delete-reconciliation-details"]'
    )

    if (!deleteButton) return

    unsubscribers.forEach((callback) => {
      callback()
    })

    deleteButton.addEventListener('click', handleClick)

    unsubscribers.push(() => {
      deleteButton.removeEventListener('click', handleClick)
    })
  })
}

function handleClick(event) {
  event.preventDefault()

  const deleteButton = event.target
  const { url, message, confirmationName } = deleteButton.dataset

  deleteReconcilliationDetails(url, message, confirmationName)
}
